import { SitePal } from 'sitepal-react-v2';

function Char3D() {

    const start = () => {
        document.messageForm.message.value += "start event received.\n";
        window.initialClick = true;

        window.portalArrayObjects = window.portalArray.reduce((acc, item) => {
            const key = Object.keys(item)[0];
            acc[key] = item[key];
            return acc;
        }, {});

        window.currentStep = 1;
        conversation();
        setTimeout(() => {
            window.initialClick = false;
        }, 2000);
    }

    const conversation = () => {

        var currentStep = window.currentStep;
        var a = window.portalArrayObjects['abc'];
        var b = window.portalArrayObjects['xyz'];

        switch (currentStep) {
            case 1:
                window.selectPortal(b);
                window.setGaze(270, 5, 100);
                window.selectPortal(a);
                window.sayText('Welcome to the SitePal conversation example page', 2, 1, 3);
                break
            case 2:
                window.selectPortal(a);
                window.setGaze(90, 5, 100);
                window.selectPortal(b);
                window.sayText('When multiple Scenes are embedded on the same page, only one of them accepts API calls at any given time.', 1, 1, 3);
                break
            case 3:
                window.selectPortal(b);
                window.setGaze(270, 5, 100);
                window.selectPortal(a);
                window.sayText('The "Select Portal" call can be used to select the Scene that accepts API calls.', 2, 1, 3);
                break
            case 4:
                window.selectPortal(a);
                window.setGaze(90, 5, 100);
                window.selectPortal(b);
                window.sayText('To use this call, you must collect the Scene reference when the embedded Scene is loaded – by assigning the values returned by the “Embed” function', 1, 1, 3);
                break
        }
    }

    window.vh_audioEnded = function () {
        if (window.initialClick) {
            window.initialClick = false;
            return;
        }
        document.messageForm.message.value += "Received vh_talkEnded(); \n";
        setTimeout(() => {
            window.currentStep += 1;
            conversation();
        }, 100);
    }


    return (
        <div>
            <header className="main_header">
                <div className="left_div">
                    <div className="logo logo_heading">
                        <a href="/"><img src="https://www.sitepal.com/api/examples/images/logo.png" alt="SitePal" /></a>
                    </div>
                </div>
            </header>

            <table id="tblContainer" cellSpacing="0" align="center" border="0" width="50%" style={{ minHeight: "73vh" }}>
                <tbody>
                    <tr>
                        <td id="tdContent">
                            <p className="feature_entire_heading text-center f-bold h2" align="center"><b>SitePal Conversation Example in React JS</b></p>
                            <p className="feature_entire_heading text-center" align="center">Two characters have a conversation</p>
                            <table width="90%" align="center">
                                <tbody>

                                    <tr>
                                        <td align="center">
                                            <SitePal spn="abc"
                                                embed='3432155,300,400,"",1,1, 2695938, 0,1,1,"83e9cf749c828c00f267098eefd1eca5",0' />
                                        </td>
                                        <td align="center">
                                            <SitePal spn="xyz"
                                                embed='3432155,300,400,"",1,1, 2695693, 0,1,1,"85c776a6ec18b1e8cafedc94fdd0f31b",0' />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="center" colSpan="2">

                                            <form action="#" name="messageForm">
                                                <textarea cols="70" rows="10" name="message" readOnly className="feature_entire_heading"></textarea>
                                            </form>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="middle" colSpan="2">
                                            <span className="content"><a style={{ cursor: "pointer" }} className="selected_support" onClick={start} ><b>Start the
                                                Conversation</b></a></span>

                                        </td>
                                    </tr>
                                    <tr width="60%">
                                        <td align="left" className="feature_entire_heading" colSpan="2">
                                            The value returned by the 'AC_VHost_Embed' function is the Scene reference.
                                            The male character on the left has its Scene reference assigned to variable 'a'.
                                            The female character on the right has its Scene reference assigned to variable 'b'.
                                            The variables 'a' or 'b' are passed to the 'selectPortal' function.

                                        </td>
                                    </tr>
                                    <tr width="60%">
                                        <td align="left" className="feature_entire_heading" colSpan="2">
                                            The 'selectPortal' call determines which Scene is the active target of subsequent API calls.

                                        </td>
                                    </tr>
                                    <tr width="60%">
                                        <td align="center" className="feature_entire_heading">


                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </td>

                    </tr>
                </tbody>
            </table>

            <footer>
                <div className="footer-menu oddcast text-center">
                    <ul className="w-50 m-auto ">
                        <li className="w-100 f-bold ">Please feel free to use the source code of this page as an example.</li>
                        <li>To view the source code of this page, <a href="/api/examples/react-conversation/Sitepal-react.zip" download="">download</a>
                            souce code</li>
                    </ul>
                </div>
            </footer>
        </div>
    );
}
export default Char3D;